import { CareerSitePageSSR } from '@/p/views/career-site/career-site.page.ssr';
export default CareerSitePageSSR;
